var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlipay = function SvgIconAlipay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconAlipay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M31 .5H4A3.5 3.5 0 0 0 .5 4v16A3.5 3.5 0 0 0 4 23.5h27a3.5 3.5 0 0 0 3.5-3.5V4A3.5 3.5 0 0 0 31 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1677FF",
    d: "M23.21 3.531H11.79c-1.49 0-2.69 1.21-2.69 2.71v11.52c0 1.5 1.2 2.71 2.69 2.71h11.42c1.49 0 2.69-1.22 2.69-2.71V6.241c0-1.5-1.2-2.71-2.69-2.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.64 16.561c-2.61 0-3.39-2.08-2.09-3.21.43-.38 1.22-.57 1.64-.61 1.55-.15 2.99.44 4.69 1.28-1.19 1.57-2.71 2.55-4.23 2.55m9.28-2.4c-.67-.23-1.57-.57-2.58-.94.6-1.06 1.09-2.26 1.4-3.57h-3.31v-1.2h4.06v-.67h-4.06v-2.01h-1.66c-.29 0-.29.29-.29.29v1.72h-4.1v.67h4.1v1.2H13.1v.67h6.57c-.23.81-.55 1.59-.95 2.33-2.13-.71-4.41-1.28-5.84-.93-.91.23-1.5.63-1.85 1.06-1.59 1.95-.45 4.91 2.9 4.91 1.98 0 3.89-1.11 5.37-2.95 2.21 1.07 6.58 2.91 6.58 2.91v-2.62s-.55-.04-2.97-.86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconAlipay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v24H0z"
  })))));
};
export default SvgIconAlipay;